import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./components/Home";
import Input from "./components/Input";
import Initial from "./components/Initial";
import EncryptionView from "./components/EncryptionView";
import Page1 from "./components/Page1";
import Sbox from "./components/sbox";
import Rounds from "./components/Rounds";
import Keygen from "./components/Keygen";
import Final from "./components/FinalPermutation";
import DisplayBox from "./components/DisplayBox";
import DisplayTBox from "./components/DisplayTextBox";
import DisplayBox64Bit from "./components/displayBox64Bit";
import { HashRouter } from 'react-router-dom';


function App() {
  return (
    <HashRouter>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/"></Link>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/input" element={<Input />} />
          <Route path="/initial" element={<Initial />} />
          <Route path="/encryptionview" element={<EncryptionView />} />
          <Route path="/page1" element={<Page1 />} />
          <Route path="/sbox" element={<Sbox />} />
          <Route path="/Rounds" element={<Rounds />} />
          <Route path="/keygen" element={<Keygen />} />
          <Route path="/final" element={<Final />} />
          <Route path="/DisplayBox" element={<DisplayBox />} />
          <Route path="/DisplayTextBox" element={<DisplayTBox />} />
          <Route path="/DisplayBox64Bit" element={<DisplayBox64Bit />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
